import Registered from "utils/Registered.js";
import {FIGURES} from './constants.js';
import {uuid} from 'uuidv4';
import {hand, t_print, t_cond, j_tidal, tparse} from '../scripting/tidal.js';
import {fig} from '../scripting/t_figure.js';
import Figure from './Figure.js';
import NodeMessaging from "messaging/NodeMessaging.js";


const f3 = fig(tparse('. -'));
const f4 = fig(tparse('. . -'));
const f5 = fig(tparse('. . . -'));

export default class Figures extends NodeMessaging(Registered(class {})) {
    constructor(subSequence, zObject) {
        super();
        this.subSequence = subSequence;
        this.zObject = zObject;
        this.sequencerEngine = subSequence.sequencerEngine;
        this.id = uuid();
        this.figures = [new Figure(f3, this), new Figure(f4, this), new Figure(f5, this),
                        new Figure(f4, this)];
        this.newInlet("swap", (msg) => this.onSwap(msg));
        this.onFiguresChanged();
    }

    onSwap(msg) {
        // swap a'th and b'th indices
        let [a,b] = msg[0];
        console.log('on swap = ', a,b);

        a = a % this.figures.length;
        b = b % this.figures.length;

        if (isNaN(a) || isNaN(b)) {
            return;
        }

        let tmp = this.figures[a];
        this.figures[a] = this.figures[b];
        this.figures[b] = tmp;

        console.log('swapping', this.figures[a], this.figures[b]);

        this.onFiguresChanged();
    }

    updateFigure(oldFigure, newFigure) {
        let index = -1;
        for (let i=0; i < this.figures.length; i++ ){
            if (oldFigure === this.figures[i]) {
                index = i;
                break;
            }
        }
        newFigure = fig(tparse(newFigure));

        this.figures[index].updateFigure(newFigure);
        this.figures = [... this.figures];
        this.onFiguresChanged();
        return this.figures[index];
    }

    onFiguresChanged() {
        if (this.figures) {
            this._figures = this.figures.map(x => x.figure);
            for (let i=0; i < this._figures.length; i++ ) {
                let inlet = this.getFigureInletName(i);
                if (!this.inlets[inlet]) {
                    this.newInlet(inlet, () => this.onFigureTypeChange(i));
                }
            }
                 
        }
    }

    onFigureTypeChange(number) {
        let fig = this.figures[number];
        if (fig) {
            let types = FIGURES[fig.figureLength];
            let type = fig.figureType;
            let newType = (type + 1) % types.length;
            fig.figureTypeParameter.set(newType);
        }
    }

    newFigure() {
        this.figures = [... this.figures, new Figure(f3, this)];
        this.onFiguresChanged();
    }

    getFigureInletName(number) {
        return "figure-type-" + (number + 1);
    }

    deleteFigure(figure) {
        let index = this.figures.indexOf(figure);
        this.deleteInlet(this.getFigureInletName(figure));
        this.figures = this.figures.filter(
            f => f !== figure);
        this.onFiguresChanged();
    }

    fromJson({figures, id}) {
        let bulk = {};
        this.id = id;
        if (!figures) {
            return bulk;
        }
        for (let i=0; i < figures.length; i++) {
            let figure = figures[i];
            if (typeof figure === "string") {
                this.figures[i] = new Figure(fig(tparse(figure)), this);
                this.updateFigure(this.figures[i], figure);
            } else {
                if (!this.figures[i]) {
                    this.newFigure();
                }
                bulk = {
                    ... bulk,
                    ... this.figures[i].fromJson(figure)
                };
            }
        }
        this.figures = this.figures.slice(0, figures.length);
        this.onFiguresChanged();
        return bulk;
    }

    getJson() {
        return {
            id: this.id,
            figures: this.figures.map(x => x.getJson()),
        };
    }
}
